<div class="coaching-layout">
  <!-- Sidebar -->
  <aside class="sidebar" [class.collapsed]="isSidebarCollapsed" [class.mobile-open]="isMobileMenuOpen">
    <div class="sidebar-header">
      <div class="logo">
        <i class="fas fa-graduation-cap logo-icon"></i>
        <span class="logo-text" *ngIf="!isSidebarCollapsed">{{ appInfo.name }}</span>
      </div>
      <button class="sidebar-toggle desktop-only" (click)="toggleSidebar()">
        <i class="fas" [class.fa-chevron-left]="!isSidebarCollapsed" [class.fa-chevron-right]="isSidebarCollapsed"></i>
      </button>
    </div>

    <nav class="sidebar-nav">
      <ul class="nav-list">
        <li class="nav-item" *ngFor="let route of visibleRoutes$ | async">
          <a [routerLink]="route.path" routerLinkActive="active" class="nav-link">
            <i [class]="route.iconClass + ' nav-icon'" *ngIf="route.iconClass"></i>
            <span class="nav-text" *ngIf="!isSidebarCollapsed">{{ route.name }}</span>
            <span class="nav-tooltip">{{ route.name }}</span>
          </a>
        </li>
      </ul>
    </nav>

    <div class="sidebar-footer">
      <div class="user-info" *ngIf="(currentUser$ | async)?.isAuthenticated">
        <div class="user-avatar" *ngIf="currentUser$ | async as user">
          <i class="fas fa-user-circle" *ngIf="!user.avatar"></i>
          <img [src]="user.avatar" *ngIf="user.avatar" alt="User Avatar">
        </div>
        <div class="user-details" *ngIf="!isSidebarCollapsed && (currentUser$ | async) as user">
          <span class="user-name">{{ user.userName }}</span>
          <span class="user-role">{{ currentUserRole }}</span>
        </div>
      </div>
      <button 
        class="logout-btn" 
        *ngIf="(currentUser$ | async)?.isAuthenticated"
        (click)="onLogout()" 
        [attr.title]="'Çıkış Yap'">
        <i class="fas fa-sign-out-alt"></i>
        <span *ngIf="!isSidebarCollapsed">Çıkış Yap</span>
      </button>
      <button 
        class="logout-btn" 
        *ngIf="!(currentUser$ | async)?.isAuthenticated"
        (click)="navigateToLogin()" 
        [attr.title]="'Giriş Yap'">
        <i class="fas fa-sign-in-alt"></i>
        <span *ngIf="!isSidebarCollapsed">Giriş Yap</span>
      </button>
    </div>
  </aside>

  <!-- Main Content -->
  <div class="main-wrapper">
    <!-- Top Bar -->
    <header class="topbar">
      <button class="mobile-menu-toggle" (click)="toggleMobileMenu()">
        <i class="fas fa-bars"></i>
      </button>

      <div class="topbar-left">
        <h1 class="page-title">Dashboard</h1>
      </div>

      <div class="topbar-right">
        <!-- Quick Actions -->
        <div class="quick-actions">
          <button class="action-btn timer-btn" *ngIf="currentUserRole === 'student'">
            <i class="fas fa-stopwatch"></i>
            <span class="desktop-only">Timer</span>
          </button>
        </div>

        <!-- Notifications -->
        <div class="notifications">
          <button class="notification-btn">
            <i class="fas fa-bell"></i>
            <span class="notification-badge">3</span>
          </button>
        </div>
      </div>
    </header>

    <!-- Page Content -->
    <main class="main-content">
      <!-- Dashboard Cards (örnek) -->
      <div class="dashboard-cards" *ngIf="currentUserRole">
        <div class="stat-card primary">
          <div class="card-icon">
            <i class="fas fa-users"></i>
          </div>
          <div class="card-content">
            <h3>25</h3>
            <p>Öğrenciler</p>
          </div>
        </div>

        <div class="stat-card success">
          <div class="card-icon">
            <i class="fas fa-tasks"></i>
          </div>
          <div class="card-content">
            <h3>120</h3>
            <p>Görevler</p>
          </div>
        </div>

        <div class="stat-card warning">
          <div class="card-icon">
            <i class="fas fa-percentage"></i>
          </div>
          <div class="card-content">
            <h3>85%</h3>
            <p>Tamamlanma</p>
          </div>
        </div>

        <div class="stat-card info">
          <div class="card-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <div class="card-content">
            <h3>12</h3>
            <p>Rapor</p>
          </div>
        </div>
      </div>

      <!-- Router Outlet -->
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Mobile Overlay -->
  <div class="mobile-overlay" *ngIf="isMobileMenuOpen" (click)="toggleMobileMenu()"></div>
</div>

<!-- ABP Components -->
<abp-confirmation></abp-confirmation>